<template>
	<glass-card class="profile-container mt-2 mb-5 px-3 p-5">
		<!-- <h2>User Profile</h2> -->

		<!-- User Settings -->
		<section class="user-settings">
			<h3>User Settings</h3>
			<div class="mb-3">
				<label for="name" class="form-label">Name</label>
				<input type="text" class="form-control" id="name" v-model="user.name" />
			</div>
			<div class="mb-3">
				<label for="email" class="form-label">Email</label>
				<input
					type="email"
					class="form-control"
					id="email"
					autocomplete="new-email"
					v-model="user.email" />
			</div>
			<div class="mb-3">
				<label for="birthday" class="form-label">Birthday</label>
				<input
					type="date"
					class="form-control"
					id="birthday"
					v-model="user.birthday" />
			</div>
			<div class="mb-3">
				<label for="birthGender" class="form-label">Birth Gender</label>
				<select class="form-select" id="birthGender" v-model="user.birthGender">
					<option value="male">Male</option>
					<option value="female">Female</option>
				</select>
			</div>
			<PasswordInput
				v-model="user.currentPassword"
				label="Current Password"
				transparent="true"
				v-if="!user.social_only" />
			<PasswordWithRequirements
				v-model="user.newPassword"
				label="New Password"
				transparent="true"
				@valid="newPasswordValid = $event" />
			<PasswordInput
				v-model="user.confirmPassword"
				transparent="true"
				label="Confirm New Password" />
		</section>

		<!-- Goals -->
		<section class="goals mt-5">
			<h3>Goals</h3>
			<div class="mb-3">
				<label for="maxCalories" class="form-label">Max Daily Caloric</label>
				<input
					type="number"
					class="form-control"
					id="maxCalories"
					v-model="user.maxCalories" />
			</div>
			<div class="mb-3">
				<label for="maxCalories" class="form-label">Max Daily Carbs</label>
				<input
					type="number"
					class="form-control"
					id="maxCalories"
					v-model="user.maxCarbs" />
			</div>
			<div class="mb-3">
				<label for="maxCalories" class="form-label">Max Daily Fats</label>
				<input
					type="number"
					class="form-control"
					id="maxCalories"
					v-model="user.maxFats" />
			</div>
			<div class="mb-3">
				<label for="maxCalories" class="form-label">Max Daily Fiber</label>
				<input
					type="number"
					class="form-control"
					id="maxCalories"
					v-model="user.maxFiber" />
			</div>
			<div class="mb-3">
				<label for="maxCalories" class="form-label">Max Daily Protien</label>
				<input
					type="number"
					class="form-control"
					id="maxCalories"
					v-model="user.maxProtien" />
			</div>
			<div class="mb-3">
				<label for="maxCalories" class="form-label">Max Daily Sodium</label>
				<input
					type="number"
					class="form-control"
					id="maxCalories"
					v-model="user.maxSodium" />
			</div>
			<div class="mb-3">
				<label for="maxCalories" class="form-label">Max Daily Sugars</label>
				<input
					type="number"
					class="form-control"
					id="maxCalories"
					v-model="user.maxSugar" />
			</div>
			<!-- Add more goal inputs as needed -->
		</section>

		<!-- Meal Plan Settings -->
		<MealPlanSettings v-model="user" transparent="true" />

		<!-- Email Settings-->
		<section class="email-settings mt-5">
			<h3>Email Settings</h3>
			<div class="mb-3 form-check">
				<input
					type="checkbox"
					class="form-check-input"
					id="marketingEmails"
					v-model="user.marketing" />
				<label class="form-check-label" for="marketingEmails">
					Receive Marketing Emails
				</label>
			</div>
			<div class="mb-3 form-check">
				<input
					type="checkbox"
					class="form-check-input"
					id="weeklyUpdates"
					v-model="user.weeklyUpdates" />
				<label class="form-check-label" for="weeklyUpdates">
					Receive Weekly Updates
				</label>
			</div>
			<div class="mb-3 form-check">
				<input
					type="checkbox"
					class="form-check-input"
					id="systemNotifications"
					v-model="user.systemNotifications" />
				<label class="form-check-label" for="systemNotifications">
					System Notifications
				</label>
			</div>
			<!-- <div class="mb-3 form-check">
				<input
					type="checkbox"
					class="form-check-input"
					id="airDropNotification"
					v-model="user.airDropNotification" :checked="user.airDropNotification" />
				<label class="form-check-label" for="airDropNotification">
					Receive AirDrop Notifications
				</label>
			</div> -->
		</section>

		<!-- Other Settings -->
		<section class="other-settings mt-5">
			<h3>Other Settings</h3>
			<div class="mb-3">
				<label for="allergies" class="form-label">Allergies</label>
				<textarea
					class="form-control"
					id="allergies"
					rows="3"
					v-model="user.allergies"
					placeholder="peanuts, gluten, etc..."></textarea>
			</div>
			<div class="mb-3">
				<label for="restrictions" class="form-label">Restrictions</label>
				<textarea
					class="form-control"
					id="restrictions"
					rows="3"
					v-model="user.restrictions"
					placeholder="diabetic, heart issues, etc..."></textarea>
			</div>
		</section>

		<!-- Model Settings -->
		<section class="model-settings mt-5">
			<h3>Model Settings</h3>
			<div v-if="!SubscriptionHelper.isFreeAccount()">
				<p>
					These settings only work for plus users. Settings are for
					adding/editing food. Thinking mode will increase the time it takes to
					add/edit food but will give better results. Grounding mode will make
					it so it will use information outside from its training data to help
					it.
				</p>
				<div class="form-check form-switch">
					<input
						class="form-check-input"
						type="checkbox"
						id="thinkingMode"
						v-model="user.thinking_mode" />
					<label class="form-check-label" for="thinkingMode"
						>Thinking Mode</label
					>
				</div>
				<div class="form-check form-switch">
					<input
						class="form-check-input"
						type="checkbox"
						id="groundingMode"
						v-model="user.grounding_mode" />
					<label class="form-check-label" for="groundingMode"
						>Grounding Mode</label
					>
				</div>
			</div>
			<div v-else>
				<p>
					Thinking is off and grounding is off. Upgrade to plus to enable these
					features.
				</p>
			</div>
		</section>

		<!-- Blood Sugar Settings Section -->
		<section class="blood-sugar-settings mt-5">
			<h3>Blood Sugar Settings</h3>
			<div class="mb-3 form-check">
				<input
					type="checkbox"
					class="form-check-input"
					id="bloodSugarNotifications"
					v-model="user.bloodSugarNotifications"
					@change="handleNotificationPermission" />
				<label class="form-check-label" for="bloodSugarNotifications">
					Enable Blood Sugar Notifications
				</label>
			</div>
			<div class="mb-3">
				<label for="notificationDelay" class="form-label"
					>Notification Delay (minutes)</label
				>
				<input
					type="number"
					class="form-control"
					id="notificationDelay"
					v-model="user.bloodSugarNotificationDelay"
					step="0.5"
					min="0" />
			</div>
		</section>

		<!--Web 3 stuff -->
		<!-- <section class="web3-settings mt-5">
			<h3>Web3 Settings</h3>
			<p>
				These settings are OPTIONAL. If you want to join in on the web3 side of
				things, fill out these settings.
			</p>
			<br />
			<div class="mb-3">
				<label for="wallet" class="form-label">Wallet Address</label>
				<p>
					By putting your ETH wallet address here, you can get weekly airdrops
					of our token for logging foods.
				</p>
				<input
					type="text"
					id="wallet"
					class="form-control"
					v-model="user.walletAddress"
					placeholder="Put your ETH wallet address here for rewards" />
			</div>
		</section> -->

		<div class="text-center">
			<button
				type="submit"
				class="btn btn-lg btn-primary mt-5"
				@click="updateProfile"
				:disabled="!isOnline">
				Save Changes
			</button>
		</div>

		<!-- Fruit Rain Toggle Section -->
		<section
			class="fruit-bg-toggle mt-5 p-4 rounded border border-success-subtle bg-success-subtle">
			<h3 class="text-success">Per-Device Settings</h3>

			<div v-if="Capacitor.isNativePlatform()" class="meal-reminders mb-4">
				<h4>Meal Reminders</h4>
				<p class="mb-3">
					These reminder settings only affect this device.
				</p>

				<div
					v-for="definition in mealReminderDefinitions"
					:key="definition.key"
					class="meal-reminder-row py-3 border-bottom border-success-subtle">
					<div
						class="d-flex align-items-center justify-content-between gap-3">
						<div>
							<label
								class="form-check-label fw-semibold"
								:for="`mealReminder-${definition.key}`">
								{{ definition.label }}
							</label>
							<div class="small meal-reminder-description">
								{{ definition.description }}
							</div>
						</div>
						<div class="form-check form-switch m-0">
							<input
								class="form-check-input"
								type="checkbox"
								:id="`mealReminder-${definition.key}`"
								v-model="mealReminderSettings[definition.key].enabled"
								:disabled="mealReminderSaving"
								@change="handleMealReminderToggle(definition.key)" />
						</div>
					</div>
					<div class="mt-2">
						<label
							class="form-label small mb-1"
							:for="`mealReminderTime-${definition.key}`">
							Reminder time
						</label>
						<input
							class="form-control"
							type="time"
							:id="`mealReminderTime-${definition.key}`"
							v-model="mealReminderSettings[definition.key].time"
							:disabled="mealReminderSaving"
							@change="handleMealReminderTimeChange" />
					</div>
				</div>

				<div
					v-if="
						mealReminderPermissionStatus === 'denied' &&
						hasEnabledMealReminders(mealReminderSettings)
					"
					class="alert alert-warning mt-3 mb-0"
					role="status">
					Meal reminders are enabled here, but notifications are blocked in
					this device's system settings.
				</div>
			</div>

			<div
				class="form-check form-switch d-flex align-items-center justify-content-between">
				<label class="form-check-label" for="fruitBgToggle">
					Show Fruit Background
				</label>
				<input
					class="form-check-input"
					type="checkbox"
					id="fruitBgToggle"
					:checked="fruitBg.isOn"
					@change="fruitBg.setShowBg($event.target.checked)" />
			</div>

			<!-- Health Connect (Android) -->
			<div class="mt-3" v-if="showHealthConnectButton">
				<button
					class="btn btn-outline-success w-100"
					@click="openHealthConnect">
					<i class="bi bi-heart-pulse-fill"></i>
					&nbsp;Open Health Connect
				</button>
			</div>
		</section>

		<!-- Dangerous Actions Section -->
		<section
			class="dangerous-actions mt-5 p-4 bg-danger-subtle rounded border border-danger">
			<h3 class="text-danger">Danger Zone</h3>
			<p class="text-danger fw-bold">
				Warning: These actions cannot be undone!
			</p>

			<div class="mb-3">
				<button
					class="btn btn-outline-danger w-100 d-flex justify-content-between align-items-center"
					@click="toggleDangerZone"
					type="button">
					<span>Delete Account</span>
					<i
						:class="
							dangerZoneExpanded ? 'bi bi-chevron-up' : 'bi bi-chevron-down'
						"></i>
				</button>

				<div
					v-if="dangerZoneExpanded"
					class="mt-3 p-3 border border-danger rounded">
					<h3>
						MAKE SURE TO CANCEL ANY SUBSCRIPTION TO THIS APP YOU HAVE! IF YOU
						DON'T YOU WILL STILL BE CHARGED!
					</h3>
					<p>
						Deleting your account will permanently remove ALL your data
						including:
					</p>
					<ul>
						<li>Personal information and settings</li>
						<li>Meal plans and food logs</li>
						<li>Goal tracking and progress history</li>
						<li>All other associated data</li>
					</ul>

					<button class="btn btn-danger mt-3" @click="confirmDeleteAccount">
						Delete My Account
					</button>
				</div>
			</div>
		</section>
	</glass-card>
</template>
<script setup>
	import { ref, watch, onMounted, onBeforeUnmount } from "vue"
	import Swal from "sweetalert2"
	// import { hasTokenIssue, handleTokenIssue } from "@/utils/tokenIssue"
	import { fetchWithAuth } from "@/utils/api-client"
	import { useTokenStore } from "@/stores/token"
	import { startLoading, stopLoading } from "@/utils/loaderBus"
	import { useUserStore } from "@/stores/user"
	import { isOnline } from "@/utils/networkBus"
	import MealPlanSettings from "@/components/MealPlanSettings.vue"
	import { LocalNotifications } from "@capacitor/local-notifications"
	import { useRouter } from "vue-router"
	import PasswordInput from "@/components/PasswordInput.vue"
	import PasswordWithRequirements from "@/components/PasswordWithRequirements.vue"
	import GlassCard from "@/components/GlassCard.vue"
	import { useFruitBackground } from "@/stores/fruit-background"
	import { Capacitor } from "@capacitor/core"
	import { App as CapacitorApp } from "@capacitor/app"
	import { Health } from "@/plugins/Health"
	import { Billing } from "@/plugins/Billing"
	import * as SubscriptionHelper from "@/utils/subscriptionHelper"
	import {
		MEAL_REMINDER_DEFINITIONS,
		createDefaultMealReminderSettings,
		hasEnabledMealReminders,
	} from "@/utils/mealReminderCore"
	import {
		getMealReminderPermissionStatus,
		loadMealReminderSettings,
		reconcileMealReminders,
		requestMealReminderPermission,
		saveMealReminderSettings,
	} from "@/utils/mealReminders"

	// const tokenStore = useTokenStore()
	const userStore = useUserStore()
	const tokenStore = useTokenStore()
	const dangerZoneExpanded = ref(false)
	const router = useRouter()
	const newPasswordValid = ref(false)
	const fruitBg = useFruitBackground()
	const mealReminderDefinitions = MEAL_REMINDER_DEFINITIONS
	const mealReminderSettings = ref(createDefaultMealReminderSettings())
	const mealReminderPermissionStatus = ref("unsupported")
	const mealReminderSaving = ref(false)
	let mealReminderAppStateListener = null
	fruitBg.load()

	// Health Connect (Android) button visibility
	const showHealthConnectButton = ref(false)
	async function checkHealthConnectAvailability() {
		try {
			if (
				Capacitor.isNativePlatform() &&
				Capacitor.getPlatform() === "android"
			) {
				const { available } = await Health.isAvailable()
				showHealthConnectButton.value = !!available
			} else {
				showHealthConnectButton.value = false
			}
		} catch {
			showHealthConnectButton.value = false
		}
	}

	async function openHealthConnect() {
		try {
			if (
				Capacitor.isNativePlatform() &&
				Capacitor.getPlatform() === "android"
			) {
				// Open the Health Connect app directly via native plugin
				await Health.OpenGoogleHealthConnect()
				return
			}
			// Fallback: show message if not on Android native
			Swal.fire({
				icon: "info",
				title: "Health Connect",
				text: "Health Connect is only available on Android native.",
				confirmButtonText: "OK",
			})
		} catch (e) {
			Swal.fire({
				icon: "error",
				title: "Unable to open",
				text: "Could not open Health Connect on this device.",
			})
		}
	}

	onMounted(async () => {
		checkHealthConnectAvailability()
		if (Capacitor.isNativePlatform()) {
			mealReminderAppStateListener = await CapacitorApp.addListener(
				"appStateChange",
				({ isActive }) => {
					const userId = userStore.user?.id
					if (isActive && userId) void loadDeviceMealReminders(userId)
				}
			)
		}
	})

	onBeforeUnmount(async () => {
		await mealReminderAppStateListener?.remove()
	})

	async function loadDeviceMealReminders(userId) {
		if (!Capacitor.isNativePlatform() || !userId) return
		mealReminderSettings.value = await loadMealReminderSettings(userId)
		mealReminderPermissionStatus.value =
			await getMealReminderPermissionStatus()
	}

	async function saveDeviceMealReminders({ requestPermission = false } = {}) {
		const userId = userStore.user?.id
		if (!Capacitor.isNativePlatform() || !userId) return

		mealReminderSaving.value = true
		try {
			mealReminderSettings.value.introSeen = true
			mealReminderSettings.value = await saveMealReminderSettings(
				userId,
				mealReminderSettings.value
			)

			if (requestPermission) {
				mealReminderPermissionStatus.value =
					await requestMealReminderPermission()
			} else {
				mealReminderPermissionStatus.value =
					await getMealReminderPermissionStatus()
			}

			await reconcileMealReminders(userId)
		} catch (error) {
			console.error("Unable to save meal reminder settings", error)
			await Swal.fire({
				icon: "error",
				title: "Unable to save",
				text: "Your meal reminder settings could not be saved on this device.",
			})
		} finally {
			mealReminderSaving.value = false
		}
	}

	async function handleMealReminderToggle(reminderKey) {
		const needsPermission =
			mealReminderSettings.value[reminderKey].enabled &&
			mealReminderPermissionStatus.value !== "granted"
		await saveDeviceMealReminders({ requestPermission: needsPermission })
	}

	async function handleMealReminderTimeChange() {
		const needsPermission =
			hasEnabledMealReminders(mealReminderSettings.value) &&
			mealReminderPermissionStatus.value !== "granted"
		await saveDeviceMealReminders({ requestPermission: needsPermission })
	}

	const user = ref({
		name: "",
		email: "",
		currentPassword: "",
		newPassword: "",
		confirmPassword: "",
		maxCalories: "",
		maxCarbs: "",
		maxFats: "",
		maxFiber: "",
		maxProtien: "",
		maxSodium: "",
		maxSugars: "",
		timesToEatOut: "",
		dislikes: "",
		likes: "",
		additionalInfo: "",
		allergies: "",
		restrictions: "",
		cookForNumPeople: 1,
		birthday: "",
		birthGender: "",
		dietDescription: "",
		weeklyUpdates: true,
		marketing: true,
		airDropNotification: true,
		walletAddress: "",
		bloodSugarNotifications: false,
		bloodSugarNotificationDelay: 120,
		systemNotifications: true,
		social_only: false,
		thinking_mode: true,
		grounding_mode: true,
	})

	// const diet = ref("")

	// const handleDietChange = () => {
	// 	user.value.dietDescription = diet.value
	// 	diet.value = ""
	// }

	const handleNotificationPermission = async () => {
		if (user.value.bloodSugarNotifications) {
			try {
				const permissionStatus = await LocalNotifications.requestPermissions()
				if (permissionStatus.display !== "granted") {
					// Permission denied, uncheck the box
					user.value.bloodSugarNotifications = false
					// Swal.fire({
					// 	icon: "warning",
					// 	title: "Permission Denied",
					// 	text: "Notification permissions are required for blood sugar reminders.",
					// })
				}
			} catch (error) {
				console.error("Error requesting notification permissions:", error)
				user.value.bloodSugarNotifications = false
				// Swal.fire({
				// 	icon: "error",
				// 	title: "Error",
				// 	text: "An error occurred while requesting permissions.",
				// })
			}
		}
	}

	const updateProfile = async () => {
		const u = user.value
		if (u.newPassword && !newPasswordValid.value) {
			Swal.fire({
				title: "Error!",
				text: "New password does not meet requirements.",
				icon: "error",
			})
			return
		}
		if (u.newPassword && u.newPassword !== u.confirmPassword) {
			Swal.fire({
				title: "Error!",
				text: "The passwords do not match.",
				icon: "error",
			})
			return
		}
		if (u.newPassword && !u.currentPassword && !u.social_only) {
			Swal.fire({
				title: "Error!",
				text: "In order to change password you need to put your current password for security reasons.",
				icon: "error",
			})
			return
		}
		if (!u.email) {
			Swal.fire({
				title: "Error!",
				text: "Email must be filled out.",
				icon: "error",
			})
			return
		}
		if (!u.name) {
			Swal.fire({
				title: "Error!",
				text: "name must be filled out.",
				icon: "error",
				confirmButtonText: "OK",
			})
			return
		}

		try {
			startLoading()
			const response = await fetchWithAuth("/api/update-profile", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					// Authorization: `Bearer ${tokenStore.token}`,
				},
				body: JSON.stringify(u),
			})

			stopLoading()

			// if (hasTokenIssue(response)) {
			// 	handleTokenIssue(response)
			// } else {
			const data = await response.json()

			if (response.ok) {
				// Success response handling
				await Swal.fire({
					icon: "success",
					title: "Success",
					text: data.message,
				})
				if (data.settings) {
					const settings = data.settings
					// for (const d in settings) {
					// 	if (user.value[d] !== undefined) {
					// 		user.value[d] = settings[d]
					// 	}
					// }
					userStore.setUser(settings)
				}
			} else {
				// Error response handling
				throw new Error(data.message)
			}
			// }
		} catch (error) {
			await Swal.fire({
				icon: "error",
				title: "Error",
				text: error.message || "An error occurred while updating the profile.",
			})
		}
	}

	const confirmDeleteAccount = () => {
		Swal.fire({
			title: "Are you sure?",
			text: "This will delete ALL your account data. This action cannot be undone!",
			icon: "warning",
			showCancelButton: true,
			confirmButtonColor: "#dc3545",
			cancelButtonColor: "#6c757d",
			confirmButtonText: "Yes, delete my account",
			cancelButtonText: "Cancel",
		}).then((result) => {
			if (result.isConfirmed) {
				// Here you would call the API to delete the account
				// For now we just show a confirmation message
				deleteAccount()
			}
		})
	}

	const deleteAccount = async () => {
		await deleteAccountRequest(false)
	}

	const deleteAccountRequest = async (acknowledgeAppleSubscription = false) => {
		try {
			startLoading()
			const response = await fetchWithAuth("/api/delete-account", {
				method: "DELETE",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					acknowledge_apple_subscription: acknowledgeAppleSubscription,
				}),
			})
			stopLoading()

			const data = await response.json()

			if (response.ok) {
				await Swal.fire({
					icon: "success",
					title: "Account Deleted",
					text: data.message || "Your account has been deleted successfully.",
				})
				// Clear tokens and log the user out
				await tokenStore.clearTokens()
				router.push("/")

				//clear user store too
				userStore.setUser(null)
				userStore.setActingAsUser(null)
			} else if (response.status === 409 && data.requiresAppleSubscriptionConfirmation) {
				const result = await Swal.fire({
					icon: "warning",
					title: "App Store Subscription Still Active",
					text:
						data.message ||
						"Apple keeps billing subscriptions active until you cancel them in the App Store.",
					showCancelButton: true,
					showDenyButton: true,
					confirmButtonText: "Delete Anyway",
					denyButtonText: "Manage Subscription",
					cancelButtonText: "Keep Account",
				})

				if (result.isDenied) {
					if (
						Capacitor.isNativePlatform() &&
						Capacitor.getPlatform() === "ios"
					) {
						await Billing.manageSubscription()
					} else if (data.manageUrl) {
						window.open(data.manageUrl, "_blank", "noopener,noreferrer")
					}
					return
				}

				if (result.isConfirmed) {
					await deleteAccountRequest(true)
					return
				}
			} else {
				throw new Error(data.message || "Failed to delete account")
			}
		} catch (error) {
			stopLoading()
			await Swal.fire({
				icon: "error",
				title: "Error",
				text: error.message || "An error occurred while deleting your account.",
			})
		}
	}

	const toggleDangerZone = () => {
		dangerZoneExpanded.value = !dangerZoneExpanded.value
	}

	watch(
		// () => userStore.user,
		() => userStore.user,
		(v, ov) => {
			// console.log(v)
			// 	fetchProfile()
			if (v) {
				for (const d in v) {
					if (user.value[d] !== undefined) {
						if (
							[
								"marketing",
								"weeklyUpdates",
								"airDropNotification",
								"bloodSugarNotifications",
								"systemNotifications",
								"thinking_mode",
								"grounding_mode",
								"social_only",
							].includes(d)
						) {
							user.value[d] = !!+v[d]
						} else {
							user.value[d] = v[d]
						}
						// console.log(d, user.value[d])
					}
				}
			}
		},
		{ immediate: true, deep: true }
	)

	watch(
		() => userStore.user?.id,
		(userId) => {
			if (userId) void loadDeviceMealReminders(userId)
		},
		{ immediate: true }
	)
</script>

<style scoped>
	.profile-container {
		max-width: 600px;
		margin: 0 auto;
	}

	/* .user-settings,
	.goals,
	.meal-plan-settings { */
	section {
		margin-bottom: 2rem;
	}

	h3 {
		margin-bottom: 1rem;
	}

	.form-label {
		font-weight: bold;
	}

	/* Transparent inputs for this view */
	.form-control,
	.form-select {
		background-color: transparent !important;
		color: #ffffff !important;
		border-color: rgba(255, 255, 255, 0.25);
	}
	.form-control:focus,
	.form-select:focus {
		background-color: transparent !important;
		color: #ffffff !important;
		box-shadow: 0 0 0 0.2rem rgba(34, 197, 94, 0.25);
		border-color: #22c55e;
	}

	.form-select {
		color-scheme: dark;
		background-image: url("data:image/svg+xml;charset=UTF-8,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='white' viewBox='0 0 16 16'><path d='M4.646 6.646a.5.5 0 0 1 .708 0L8 9.293l2.646-2.647a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 0 1 0-.708z'/></svg>");
		background-repeat: no-repeat;
		background-position: right 0.75rem center;
		background-size: 1.5em 1.5em;
	}

	textarea.form-control {
		color: #ffffff !important;
	}
	textarea.form-control::placeholder {
		color: #b0b0b0 !important;
		opacity: 1;
	}

	.meal-reminders h4 {
		margin-bottom: 0.25rem;
	}

	.meal-reminders {
		color: #123b2b;
	}

	.meal-reminders .form-check-label,
	.meal-reminders .form-label {
		color: #123b2b;
	}

	.meal-reminder-description {
		color: #3f5f52;
	}

	.meal-reminders .form-control {
		background-color: rgba(255, 255, 255, 0.9) !important;
		color: #102a20 !important;
		border-color: rgba(18, 59, 43, 0.35);
	}

	.meal-reminders .form-control:focus {
		background-color: #ffffff !important;
		color: #102a20 !important;
	}

	.meal-reminder-row:last-of-type {
		border-bottom: 0 !important;
	}
</style>
